import React from "react";
import SportCode from "components/common/SportCode";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import SvgMirs from "components/presentation/SvgMirs";


export function ScoreContainer(props) {
  const { resultObj } = props;
  const { mirs_discipline } = useUrlFriendlyToParameters()
  const result = resultObj?.result;

  const winingDecision = resultObj?.extra?.resCode
  const winner = resultObj?.wlt?.trim() === 'W' && <SvgMirs className='mirsIcon score-winner' title='HeaderWinner' code='circle-check' />
  const decision = (winingDecision) && <SportCode discipline={mirs_discipline} code={winingDecision} entity="@ResultCode" abbr={true} />

  return (
    <div className='score-result-container d-flex justify-content-end align-self-center align-items-center'>
      <div className={winner ? 'score-winner' : 'score-winner'}>
        {winner}
      </div>

      <div className={`score-result ${resultObj?.rCn ? resultObj?.rCn : 'fw-bold'} text-end `} >
        {result}
      </div>

      <div className='score-decision'>{decision}</div>

      {resultObj?.hasIRM === true
        ? <div className={` p-0 fw-bold text-end score-irm`}>
          <SportCode discipline={mirs_discipline} code={resultObj?.irm} entity="@IRM" abbr={true} />
        </div>
        : ''
      }
    </div>
  )
}

export default ScoreContainer